import { render, staticRenderFns } from "./ValidateExpenseFooter.vue?vue&type=template&id=babfb73c&scoped=true&"
import script from "./ValidateExpenseFooter.vue?vue&type=script&lang=js&"
export * from "./ValidateExpenseFooter.vue?vue&type=script&lang=js&"
import style0 from "./ValidateExpenseFooter.vue?vue&type=style&index=0&id=babfb73c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "babfb73c",
  null
  
)

export default component.exports